//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
let d=[[[0,"AxisOption",1,0],[0,"Csys",1,"CoordinateSystem",0],[0,"FixedCsys",1,"NXObject",0],[0,"PlaneOption",1,0],[0,"ProgramDefinedCsys",1,"NXObject",0],[0,"ReferenceOption",1,0]],[],[]];
SPLM.GeometricUtilities.OrientXpressBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.OrientXpressBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.OrientXpressBuilder.Axis = Object.freeze({
    "X" : "X", "Y" : "Y", "Z" : "Z", "Passive" : "Passive"});

SPLM.GeometricUtilities.OrientXpressBuilder.Plane = Object.freeze({
    "Yz" : "Yz", "Xz" : "Xz", "Xy" : "Xy", "Passive" : "Passive"});

SPLM.GeometricUtilities.OrientXpressBuilder.Reference = Object.freeze({
    "AcsWorkPart" : "AcsWorkPart", "AcsDisplayPart" : "AcsDisplayPart", "WcsWorkPart" : "WcsWorkPart", "WcsDisplayPart" : "WcsDisplayPart", "Csys" : "Csys", "Fixed" : "Fixed", "ProgramDefined" : "ProgramDefined", "PathOrientation" : "PathOrientation"});

export default SPLM;